import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class InstantOfferSellerValueObject extends ValueObject {
  /**
   * @param {Object}  deps
   * @param {Object}  deps.appraisal
   * @param {Number}  deps.appraisal.minPrice
   * @param {Number}  deps.appraisal.maxPrice
   * @param {String}  deps.appraisal.title
   */
}
